import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as outcomes from '../../outcomes'

export const RESOURCE = {
  payload: {
    description:
      'The fundamental purpose and overarching direction that defines what the institution exists to achieve',
    dimension: outcomes.RESOURCE.payload,
    level: 0,
    name: 'Mission',
    partialId: PartialId.Standard.create('mission'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
